import { render, staticRenderFns } from "./UserInput.vue?vue&type=template&id=2bbe6e41&"
import script from "./UserInput.vue?vue&type=script&lang=js&"
export * from "./UserInput.vue?vue&type=script&lang=js&"
import style0 from "./UserInput.vue?vue&type=style&index=0&id=2bbe6e41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports